<template>
  <div class="step-success pt-10 pb-9 px-0">
    <div v-html="require('@/assets/img/check-round.svg')" class="mb-6 step-success__image"></div>
    <bim-text bold type=accent class="mb-6 step-success__title">Заявка отправлена</bim-text>
    <bim-text type=medium bold>Спасибо за заявку!</bim-text>
    <bim-text type=medium>В ближайшее время мы вам перезвоним.</bim-text>

    <bimButton
      class="mt-11"
      label="Принято"
      @click.native.stop.prevent="validate"
    />
  </div>
</template>

<script>
import bimButton from '@/components/form/bimButton/bimButton'
import bimText from '@/components/text/bimText/bimText'

import stepMixin from './step.mixin'

export default {
  mixins: [stepMixin],
  components: {
    bimButton,
    bimText
  }
}
</script>

<style lang="scss" scoped>
.step-success {
  text-align: center;

  .step-success__title {
    color: $primary_color;
  }

  .step-success__image {
    display: flex;
    justify-content: center;

    ::v-deep svg {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
